import { CircleX } from 'lucide-react'
import { CircleAlert } from 'lucide-react'
import { CircleCheck } from 'lucide-react'

export const statusList = [ 'PAID', 'PAYMENT FAILED', 'UNPAID' ]

export const getStatusFromPaymentCode = (paymentCode) => {
  if(paymentCode === '0000') return statusList[0]
  else if(paymentCode === '5511' || paymentCode === '5510') return statusList[2]
  else return statusList[1]
}

export const getDataList = (
  campus,
  studentId,
  name,
  acadProg,
  invoiceNumber,
  totalAmount
) => [
  {
    label: 'Campus',
    value: campus ?? '-'
  },
  {
    label: 'Student ID',
    value: studentId ?? '-'
  },
  {
    label: 'Name',
    value: name ?? '-'
  },
  {
    label: 'Academic Program',
    value: acadProg ?? '-'
  },
  {
    label: 'Invoice Number',
    value: invoiceNumber ?? '-'
  },
  {
    label: 'Total Amount',
    value: formatRupiah(totalAmount ?? 0) ?? '-'
  }
].filter(item => item.value)

const statusIconCommonClassNames = 'w-32 h-32'

export const getStatusIcon = (status) => {
  if(status === statusList[0])
    return <CircleCheck className={`${statusIconCommonClassNames} text-green-500`} />
  else if(status === statusList[1])
    return <CircleX className={`${statusIconCommonClassNames} text-red-500`} />
  else if(status === statusList[2])
    return <CircleAlert className={`${statusIconCommonClassNames} text-yellow-500`} />
}

export const getStatusTitleAndDescription = (status, email, paymentCode) => {
  if(status === statusList[0]) return {
    title: 'THANK YOU',
    description: `Your payment has been processed successfully!. We will send you a confirmation email shortly to ${email}`
  }
  else if(status === statusList[1]) return {
    title: 'TRANSACTION FAILURE',
    description: 'Your transaction failed. Please try again. If the problem still persists, please contact our Customer Service at 021-5460901.'
  }
  else if(status === statusList[2]) return {
    title: 'IMPORTANT NOTICE',
    description:  `Please proceed to complete your transaction while payment code is still valid for 1 hour. Your Virtual Account Number/Payment Code is ${paymentCode ?? '-'}`
  }
}

export function formatRupiah(amount) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0
  }).format(amount)
}